import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/toaster';
import { SmokeBackground } from '../components/ui/spooky-smoke-animation';

const Home = () => {
  return (
    <div className="min-h-screen bg-black text-white font-trillex selection:bg-trillex-orange selection:text-white relative">
      {/* Animated smoke background covering the full viewport */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <SmokeBackground smokeColor="#ff2040" className="w-full h-full block" />
        {/* Slight dark overlay to keep contrast */}
        <div className="absolute inset-0 bg-black/35" />
      </div>

      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <About />
          <Contact />
        </main>
        <Footer />
      </div>
      <Toaster />
    </div>
  );
};

export default Home;
